import { axiosClient, AxiosContext, type AxiosProviderConfig } from "./AxiosContext";

interface AxiosProviderProps {
  children: React.JSX.Element;
  config?: AxiosProviderConfig;
}

export const AxiosProvider = ({ children }: AxiosProviderProps) => {
  return <AxiosContext.Provider value={axiosClient}>{children}</AxiosContext.Provider>;
};
